module.exports = __webpack_public_path__ + "static/media/align-center.84ae8ff1.svg";